import { Link } from "react-router-dom";
import { NAV_LINKS } from "./Header";
import { scrollToSection } from "../lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#241a15] px-6 py-14 md:px-10">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <div className="flex items-center gap-4">
          <img
            src="/images/logo.png"
            alt="Vintage Billard Logo"
            className="h-14 w-14 rounded-full border border-[#c9a24a]/40 object-cover"
          />
          <div>
            <p className="font-display text-xl text-[#f4ecdd]">Vintage Billard</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#c9bda9]/60">Pool · Darts · Bremen</p>
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {NAV_LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`footer-nav-${id}`}
              onClick={() => scrollToSection(id)}
              className="text-xs uppercase tracking-[0.18em] text-[#c9bda9]/70 transition-colors duration-300 hover:text-[#e3c988]"
            >
              {label}
            </button>
          ))}
        </nav>
      </div>
      <div className="mx-auto mt-12 flex max-w-6xl flex-col gap-2 border-t border-[#241a15] pt-8 text-xs text-[#c9bda9]/50 md:flex-row md:justify-between">
        <p data-testid="footer-copyright">
          © 2026 Vintage Billard · Hemelinger Heerstraße 7, 28309 Bremen ·{" "}
          <a href="tel:+4917632526128" data-testid="footer-phone-link" className="transition-colors duration-300 hover:text-[#e3c988]">
            Tel. 0176 32526128
          </a>{" "}
          ·{" "}
          <a href="mailto:vintagebillard@gmail.com" data-testid="footer-mail-link" className="transition-colors duration-300 hover:text-[#e3c988]">
            vintagebillard@gmail.com
          </a>
        </p>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <Link
            to="/impressum"
            data-testid="footer-impressum-link"
            className="uppercase tracking-[0.18em] transition-colors duration-300 hover:text-[#e3c988]"
          >
            Impressum
          </Link>
          <Link
            to="/datenschutz"
            data-testid="footer-datenschutz-link"
            className="uppercase tracking-[0.18em] transition-colors duration-300 hover:text-[#e3c988]"
          >
            Datenschutz
          </Link>
          <p className="font-display normal-case italic tracking-normal">Deine Auszeit am Billardtisch</p>
        </div>
      </div>
    </footer>
  );
}
